import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import CommponentOptions from './data/commponentOptions';
import { useSelector } from 'react-redux';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { useIndexedDBSyncV2 } from '../../../database/dataLocal/indexedDBHooks';
import { v4 as uuidv4 } from 'uuid';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../App';
import { addRecordToCache, createFetchDataServer, createFetchDataServerWithCallback, getTableData } from '../../../database/fetchData';

const NAME_ENTITY = 'עיר';

function CityCreate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormCities.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);
  
  const [loadingData, setLoadingData] = useState(false);
  const [loading, setLoading] = useState(true); // מצב טעינה

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataCity, getEntitiesByAttr, getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת עיר`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט

  const [countries, setCountries] = useState();
  const [cities, setCities] = useState([]);

  const myColumns = () => {
    return columns.map((field) => {
      let lock = false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled && value !== undefined,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    setCountries(context?.contextCountries.map((country) => CommponentOptions({ value: country?.unicId, label: country?.countryNameHe })));
    if (value?.unicId) {
      const data = getEntityByAttr(context?.contextCountries, 'unicId', value?.unicId);

      const initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            return {
              ...acc
            };
          },
          { id: data?.unicId }
        );

      const cities = getEntitiesByAttr(context?.contextCities, 'countryId', data?.countryId);

      setCities(cities);

      if (Object.keys(formValues).length === 0) {
        setFormValues(initialFormValues); // newValues הם הערכים החדשים שברצונך לעדכן
      }
    }
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading]);

  const fieldChangeCountryId = (event) => {
    const cities = getEntitiesByAttr(context?.contextCities, 'countryId', event.target.value);

    setCities(cities);
  };

  const handleChange = (event) => {
    let newFormValues = formValues;

    if (event.target.name === 'countryId') {
      fieldChangeCountryId(event);
    }
    setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        console.log(cities);

        if (cities.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      
      let updatedFormValues = { ...formValues };

      setLoadingData(true);

      const unicId = uuidv4()

      let res = await addOrUpdateDataCity(formValues, unicId);
      if (res === 200) {
        context?.setContextBlocks((prev) => {
          const tempCountry = context?.contextCountries.find(c => c.unicId === formValues.countryId)
          updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId, 
            countryNameHe: tempCountry.countryNameHe, countryNameEn: tempCountry.countryNameEn, };

          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

          addRecordToCache(updatedFormValues, 'dataCities');

          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, updatedFormValues];
          }
        });
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCountries = localTempData.find((item) => item.name === 'dataCountries');
        const dataCities = localTempData.find((item) => item.name === 'dataCities');
        if (dataCountries && dataCities) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['cities'], token, handlePartialUpdate);
        
        fetchDataServer(['countries'], token);
      }
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return <FormTemplate title={`הוספת ${NAME_ENTITY}`} btn={`שמור`} fields={fieldsWithDynamicDisabled} columns={columns} formValues={formValues} handleChange={handleChange} handleSubmit={handleSubmit} errors={errors} options={{ countryId: countries }} />;
}

export default CityCreate;
